import { TextField, Icon, Button, Select } from '@shopify/polaris';
import { SearchIcon } from '@shopify/polaris-icons';
import { useSafeAppBridge } from "../hooks";
export function ResourcePicker(props) {
    const shopify = useSafeAppBridge();

    return (
        <TextField
            value={''}
            placeholder={props.methodType === 1 ? 'Search collections' : 'Search products'}
            prefix={<Icon source={SearchIcon} tone="subdued" />}
            error={props.errorType ? (props.errorText ?? true) : ''}
            connectedLeft={
                props.showMethodSelect ?
                    <Select
                        value={props.method === 'get' ? props.getType : props.buyType}
                        onChange={(newValue) => props.handleChange(props.method === 'get' ? 'getType' : 'buyType', newValue)}
                        options={[{ label: 'Specific products', value: 2 }, { label: 'Specific collections', value: 1 }]}
                    />
                    : null
            }
            connectedRight={<Button size="large" onClick={async () => {
                if (shopify) {
                    const res = await shopify.resourcePicker({
                        multiple: true,
                        type: props.methodType === 1 ? "collection" : "product",
                        query: '',
                        selectionIds: props.selectionIds,
                    });
                    props.handleResourcePickerSelection(res, props.method, props.getType, props.buyType, props.excludeType, props.singleMethod);
                }
                else {
                    //custom logic here
                }
            }}>Browse</Button>}
            onChange={async (newValue) => {
                if (shopify) {
                    const res = await shopify.resourcePicker({
                        multiple: true,
                        type: props.methodType === 1 ? "collection" : "product",
                        query: newValue,
                        selectionIds: props.selectionIds,
                    });
                    props.handleResourcePickerSelection(res, props.method, props.getType, props.buyType, props.excludeType, props.singleMethod);
                }
                else {
                    //custom logic here
                }
            }}
        />
    );
}